import React, { useEffect, useState } from 'react';
import { Fill, toFabricFill } from '../../shared/utils/fill';
import { StrokeControls } from '../../shared/ui/stroke-controls';
import { PillTextbox } from '../types';
import { setPillStroke, setPillStrokeWidth } from '../utils/pill-accessors';
import { usePillContent } from '../hooks/use-pill-content';
import { rowStyle, sectionStyle } from './pill-styles';

const DEFAULT_STROKE = '#000000';

type Props = { pill: PillTextbox };

export const PillStrokeRow: React.FC<Props> = ({ pill }) => {
  const { content, patch } = usePillContent(pill);
  const [stroke, setStrokeState] = useState<Fill>({ kind: 'solid', color: DEFAULT_STROKE });
  const [strokeWidth, setStrokeWidthState] = useState(0);

  useEffect(() => {
    if (!content) return;
    setStrokeState({ kind: 'solid', color: content.stroke || DEFAULT_STROKE });
    setStrokeWidthState(content.strokeWidth);
  }, [content]);

  const previewFill = (v: Fill) => {
    setStrokeState(v);
    const f = toFabricFill(v);
    setPillStroke(pill, typeof f === 'string' ? f : DEFAULT_STROKE);
  };

  const commitFill = (v: Fill) => {
    previewFill(v);
    if (v.kind === 'solid') patch({ stroke: v.color });
  };

  const previewWidth = (w: number) => {
    setStrokeWidthState(w);
    setPillStrokeWidth(pill, w);
  };

  return (
    <div style={sectionStyle}>
      <div style={rowStyle}>
        <StrokeControls
          fill={stroke}
          width={strokeWidth}
          onPreviewFill={previewFill}
          onCommitFill={commitFill}
          onPreviewWidth={previewWidth}
          onCommitWidth={() => patch({ strokeWidth })}
        />
      </div>
    </div>
  );
};
